import userApi from '@/api/now/userApi'
import store from '@/store'

let filterService = {
  async setBanks() {
    if (store.state.filter.banks.isLoading === true) {
      return
    }
    store.dispatch('filter/setBanksLoading', true)

    let banks = []
    try {
      let { data } = await userApi.getBanks()
      let keys = Object.getOwnPropertyNames(data)
      keys.forEach(bankCode => {
        let obj = {}
        obj.bankCode = bankCode
        obj.bankName = data[bankCode].replace(/[은행|증권]/g, '')

        banks.push(obj)
      })

      store.dispatch('filter/setBanks', banks)
    } catch (e) {
      console.error(e, 'filter-getBanks')
    } finally {
      store.dispatch('filter/setBanksLoading', false)
    }
  }
}
export default filterService
